import { messageError } from '../../components/message';
import { withAPIAccount } from '../../lib/http/api';
import { APIError, parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIresponse } from '../../model';
import { CommonStatusStep, IAPIUserInfo } from '../../model/api-modules';
import { API_PREFIX } from '../config';
export * from './access-token';
// 账户信息
export const getUserInfo = (isNotLogout = false) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/user/info`;
      const response = await api.commonRequest('GET', url);

      const res = await parsedResponse<IAPIUserInfo | null>(
        response,
        'data',
        isNotLogout
      );
      return res;
    } catch (error) {
      console.log('failed: getUserInfo', error);
      if (error instanceof APIError && error.responseStatus !== 401) {
        messageError(error.message);
      }
      return null;
    }
  });

// 账户信息-文档中心使用，不报错
export const getUserInfoDoc = (isNotLogout = false) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/user/info`;
      const response = await api.commonRequest('GET', url);

      const res = await parsedResponse<IAPIUserInfo | null>(
        response,
        'data',
        isNotLogout
      );
      return res;
    } catch (error) {
      console.log('failed: getUserInfo', error);
      return null;
    }
  });

export const getLoginStatus = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/user/info`;
      const response = await api.commonRequest('GET', url);
      await parsedResponse<IAPIUserInfo | null>(response, 'data', true);
      return CommonStatusStep.Resolve;
    } catch (error) {
      if (error instanceof APIError && error.responseStatus === 401) {
        return CommonStatusStep.Reject;
      }
      return null;
    }
  });

// 账户修改名称
export const putUserChangeApi = (
  username: string,
  oldPassword?: string,
  newPassword?: string
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/user/changed`;
      const response = await api.commonRequest('PUT', url, {
        username,
        oldPassword,
        newPassword,
      });
      return await parsedResponse<IAPIresponse>(response);
    } catch (error) {
      console.error('failed: putUsernameApi', error);
      // if (error instanceof APIError) {
      //   messageError(error.message);
      // }
      return null;
    }
  });

// 删除账号
export const deleteUserApi = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/user`;
      const response: Response = await api.commonRequest('DELETE', url);
      return await parsedResponse<IAPIresponse>(response);
    } catch (error) {
      // if (error instanceof APIError) {
      //   messageError(error.message);
      // }
      throw error;
    }
  });

// 修改账号密码
export const newUserChangePassword = (
  username: string,
  oldPassword?: string,
  newPassword?: string
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/user/changed-password `;
      const response = await api.commonRequest('PUT', url, {
        username,
        oldPassword,
        newPassword,
      });
      return await parsedResponse<IAPIresponse>(response);
    } catch (error) {
      console.error('failed: putUsernameApi', error);
      // if (error instanceof APIError) {
      //   messageError(error.message);
      // }
      return {};
    }
  });
